import styled from "styled-components";
import Ellipsis from "../icons/Ellipsis";
import PopMenuButton, { PopMenuProps } from "../pop-menu-button/PopMenuButton";

const OptionsMenuElement = styled.div``;

type Props = React.ComponentPropsWithoutRef<typeof OptionsMenuElement> & {
  options: PopMenuProps["options"];
};
const OptionsMenu: React.FC<Props> = ({ name, options, ...props }) => {
  return (
    <OptionsMenuElement {...props}>
      <PopMenuButton name={name} options={options}>
        <Ellipsis />
      </PopMenuButton>
    </OptionsMenuElement>
  );
};

export default OptionsMenu;
